var styles = {"file-container":"styles_file-container__2cBgd flex items-center","fileContainer":"styles_file-container__2cBgd flex items-center","attachment-icon":"styles_attachment-icon__1wfFa","attachmentIcon":"styles_attachment-icon__1wfFa","file-name":"styles_file-name__2lkMt","fileName":"styles_file-name__2lkMt"};

export default styles;
//# sourceMappingURL=styles.css.js.map
